module.exports = __webpack_public_path__ + "img/Home.6d6a564d.svg";